import axios from "axios";
import { AES, enc } from "crypto-js";
import create from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "./App";
import { Order } from "./ui/Tables";

export enum Role {
  NONE = "",
  USER = "USER",
  ADMIN = "ADMIN",
  CLUB_ADMIN = "CLUB_ADMIN",
  BACKOFFICE = "BACKOFFICE",
}

export function getRole(str: string) {
  str = str.trim().toUpperCase();
  switch (str) {
    case "":
      return Role.NONE;
    case "USER":
      return Role.USER;
    case "ADMIN":
      return Role.ADMIN;
    case "CLUB_ADMIN":
      return Role.CLUB_ADMIN;
    case "BACKOFFICE":
      return Role.BACKOFFICE;
  }
  return Role.NONE;
}

export interface UserState {
  isAuthenticated: () => boolean;
  role: Role;
  token: string;
  tabelleCompatte: boolean;
  messaggi: boolean;
  setMessaggi: (messaggi: boolean) => void;
  setToken: (token: string) => void;
  setRole: (role: Role) => void;
  usersOrder: Order;
  setUsersOrder: (usersOrder: Order) => void;
  usersOrderBy: string;
  setUsersOrderBy: (usersOrderBy: string) => void;
  usersPage: number;
  setUsersPage: (usersPage: number) => void;
  usersRows: number;
  setUsersRows: (usersRows: number) => void;
  usersStato: string;
  setUsersStato: (usersStato: string) => void;
  usersFilters: { [k: string]: string | number };
  setUsersFilters: (usersFilters: { [k: string]: string | number }) => void;
}

let globalToken = "";

const SECRET = "123hjk75sdfngiu4iuu876n0a87219n39";
let lastInterceptorId = 0;

function setBearerToken(token: string) {
  try {
    queryClient.invalidateQueries();
  } catch (ex) {}

  try {
    if (lastInterceptorId !== 0) axios.interceptors.request.eject(lastInterceptorId);
  } catch (ex) {}

  globalToken = token;

  lastInterceptorId = axios.interceptors.request.use(function (config) {
    if (globalToken !== "")
      config.headers = {
        Authorization: "Bearer " + globalToken,
      };
    else
      config.headers = {
        Authorization: "",
      };
    return config;
  });
}

export const oraPrenotaStore = create<UserState>(
  persist(
    (set, get) => ({
      role: Role.NONE,
      token: "",
      tabelleCompatte: true,
      messaggi: false,
      setMessaggi: (messaggi: boolean) => set((state) => ({ messaggi })),
      isAuthenticated: () => get().token !== "",
      setRole: (role: Role) => set((state) => ({ ...state, role })),
      setToken: (token: string) =>
        set((state) => {
          setBearerToken(token);
          return { ...state, token };
        }),
      usersOrder: "asc",
      setUsersOrder: (usersOrder: Order) => set({ usersOrder }),
      usersOrderBy: "cognome",
      setUsersOrderBy: (usersOrderBy: string) => set({ usersOrderBy }),
      usersPage: 0,
      setUsersPage: (usersPage: number) => set({ usersPage }),
      usersRows: 25,
      setUsersRows: (usersRows: number) => set({ usersRows }),
      usersStato: "1",
      setUsersStato: (usersStato: string) => set({ usersStato }),
      usersFilters: {},
      setUsersFilters: (usersFilters: { [k: string]: string | number }) => set({ usersFilters }),
    }),
    {
      name: "oraPrenota-Store",
      getStorage: () => localStorage,
      serialize: (state) => {
        const token: string = state.state.token
          ? AES.encrypt(state.state.token, SECRET).toString()
          : "";
        return JSON.stringify({
          ...state,
          state: { ...state.state, token },
        });
      },
      deserialize: (str) => {
        try {
          const state = JSON.parse(str);
          let token = AES.decrypt(state.state.token, SECRET);
          let token2 = token.toString(enc.Utf8);
          state.state.token = token2;

          if (token2 !== "") setBearerToken(token2);

          return state;
        } catch (err) {
          return { role: Role.USER, token: "" };
        }
      },
    }
  )
);
